// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hostess-income-rank-base {\n  width: 100%;\n  min-height: calc(100vh - 4rem);\n}\n.hostess-income-rank-base .custom-nav-block .van-bar .van-nav-bar__content .van-nav-bar__title {\n  color: #ffffff;\n  font-size: 0.45333rem;\n  font-family: Outfit;\n  font-weight: 600;\n}\n.hostess-income-rank-base .custom-nav-block .van-bar .van-nav-bar__content .van-nav-bar__right .tit-right {\n  line-height: 0.42667rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
